import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion"
import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from "react-scroll";

const menuItems = [
    // { title: "Home", link: "/" },
    { title: "Home", link: "/" },
    { title: "Works", link: "works" },
    { title: "Contact", link: "collab" },
]

const socialItems = [
    { title: "Twitter", link: "https://x.com/thoby_za" },
    { title: "LinkedIn", link: "https://www.linkedin.com/in/thoby-za/" },
    { title: "Email", link: "mailto:thobyy.athaya@gmail.com" },
]

export const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isGetOpen, setIsGetOpen] = useState(false)

    const handleMenuOpen = () => {
        setIsGetOpen(false)
        setIsMenuOpen(!isMenuOpen)
    }

    const handleGetOpen = () => {
        setIsMenuOpen(false)
        setIsGetOpen(!isGetOpen)
    }

    const scrollToTop = () => {
        window.scrollTo({ top: 0 })
    }

    const onItemClicked = () => {
        scrollToTop()
        setIsGetOpen(false)
        setIsMenuOpen(false)
    }

    // E0FD60
    return (
        <div className="fixed left-1/2 -translate-x-1/2 md:left-auto md:translate-x-0 bottom-[10px] md:right-[20px] md:top-[20px] font-jakarta font-medium z-50 h-max w-max">
            <div className="relative">
                <section className="p-2 bg-white bg-opacity-20 backdrop-blur-lg rounded-full shadow-[0_0.5px_2px_0px_rgb(0,0,0,0.15)]">
                    <div className="rounded-full flex gap-2">
                        <div
                            onClick={handleGetOpen}
                            className="cursor-pointer flex shrink-0 items-center rounded-full bg-[#E7F0F0] px-[1.8rem] py-[1rem] hover:bg-[#E0FD60] transition ease-in-out delay-100"
                        >
                            <span className="text-[#272932] md:text-[17px] font-semibold line-clamp-1 text-nowrap">
                                Get in touch
                            </span>
                        </div>
                        <motion.div
                            onClick={handleMenuOpen}
                            whileTap={{ scale: 0.97 }}
                            className="group cursor-pointer shrink-0 flex items-center gap-[1.75rem] md:gap-2 rounded-full bg-[#002921] pl-[1.8rem] pr-[1.6rem] py-[1rem] hover:bg-[#E0FD60] transition ease-in-out delay-100"
                        >
                            <span className="md:text-[17px] text-white group-hover:text-[#121212] font-semibold">
                                Menu
                            </span>
                            {!isMenuOpen ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    className="h-[1.4rem] w-[1.4rem] stroke-white group-hover:stroke-[#121212]"
                                >
                                    <g stroke-linecap="round" stroke-width="2">
                                        <path d="M5 5L19 5"></path>
                                        <path d="M5 12H19"></path>
                                        <path d="M5 19L19 19"></path>
                                    </g>
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    className="h-[1.4rem] w-[1.4rem] stroke-white group-hover:stroke-[#121212]"
                                >
                                    <g stroke-linecap="round" stroke-width="2">
                                        <path d="M5 5L19 5">
                                            <animate
                                                fill="freeze"
                                                attributeName="d"
                                                begin="0.2s"
                                                dur="0.4s"
                                                values="M5 5L19 5;M5 5L19 19"
                                            />
                                        </path>
                                        <path d="M5 12H19">
                                            <animate
                                                fill="freeze"
                                                attributeName="d"
                                                dur="0.4s"
                                                values="M5 12H19;M12 12H12"
                                            />
                                            <set attributeName="opacity" begin="0.4s" to="0" />
                                        </path>
                                        <path d="M5 19L19 19">
                                            <animate
                                                fill="freeze"
                                                attributeName="d"
                                                begin="0.2s"
                                                dur="0.4s"
                                                values="M5 19L19 19;M5 19L19 5"
                                            />
                                        </path>
                                    </g>
                                </svg>
                            )}
                        </motion.div>
                    </div>
                </section>
                <AnimatePresence>
                    {isMenuOpen && (
                        <motion.section
                            initial={{ opacity: 0, y: 0, height: 0 }}
                            animate={{ opacity: 1, y: 0, height: "auto" }}
                            exit={{ opacity: 0, y: 0, height: 0 }}
                            transition={{
                                type: "spring",
                                bounce: 0,
                                duration: 0.7,
                            }}
                            className="absolute bottom-[5.25rem] md:static w-full rounded-2xl bg-white mt-[0.8rem] shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.04)]"
                        >
                            <div className="flex flex-col gap-[1rem] md:text-[17px] text-[#272932] font-semibold py-[1.4rem] px-[2.2rem]">
                                {menuItems.map((item, index) => (
                                    <motion.span
                                        key={index}
                                        initial={{ opacity: 0, y: -20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3, delay: index * 0.2 }}
                                        className="cursor-pointer"
                                    >
                                        {item.link === "/" ? (
                                            <RouterLink
                                                id="underline-effect"
                                                to={item.link}
                                                onClick={onItemClicked}
                                            >
                                                {item.title}
                                            </RouterLink>
                                        ) : (
                                            <ScrollLink
                                                id="underline-effect"
                                                to={item.link}
                                                onClick={onItemClicked}
                                                smooth={true}
                                                duration={500}
                                                offset={0} // Adjust the offset if needed
                                            >
                                                {item.title}
                                            </ScrollLink>
                                        )}
                                    </motion.span>
                                ))}
                            </div>
                        </motion.section>
                    )}
                    {isGetOpen && (
                        <motion.section
                            initial={{ opacity: 0, y: 0, height: 0 }}
                            animate={{ opacity: 1, y: 0, height: "auto" }}
                            exit={{ opacity: 0, y: 0, height: 0 }}
                            transition={{
                                type: "spring",
                                bounce: 0,
                                duration: 0.7,
                            }}
                            className="absolute bottom-[5.25rem] md:static w-full rounded-2xl bg-white mt-[0.8rem] shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.04)]"
                        >
                            <div className="flex flex-col gap-[1rem] md:text-[17px] text-[#272932] font-semibold py-[1.4rem] px-[2.2rem]">
                                {socialItems.map((item, index) => (
                                    <motion.span
                                        key={index}
                                        initial={{ opacity: 0, y: -20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3, delay: index * 0.2 }}
                                    >
                                        <a
                                            id="underline-effect"
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={onItemClicked}
                                            className="leading-[1.1rem]"
                                        >
                                            {item.title}
                                        </a>
                                    </motion.span>
                                ))}
                            </div>
                        </motion.section>
                    )}
                </AnimatePresence>
            </div>
        </div>
        // #E0FD60
        // #272932
    );
};
